// frontend/src/components/calendar/CALENDAR_CONFIG.js

export const STATUS_COLORS = {
    scheduled: '#6366f1',
    published: '#22c55e',
    failed: '#ef4444',
    cancelled: '#94a3b8',
};

export const STATUS_LABELS = {
    scheduled: 'Scheduled',
    published: 'Published',
    failed: 'Failed',
    cancelled: 'Cancelled',
};

// Maps platform → the field that holds its primary text content
export const PLATFORM_CONTENT_FIELD = {
    youtube: 'title',
    instagram: 'text',
    twitter: 'text',
    facebook: 'text',
    linkedin: 'text',
    reddit: 'title',
};

export const CALENDAR_VIEWS = ['month', 'week', 'day'];

export const PLATFORM_COLORS = {
    youtube: '#ff0000',
    instagram: '#e1306c',
    twitter: '#1da1f2',
    linkedin: '#0a66c2',
    facebook: '#1877f2',
    reddit: '#ff4500',
};
